import React, { useEffect, useRef, useState } from "react";

const SingleProgress = (props) => {
  const { itemClass, progress = 90, progressClass } = props;
  const [width, setWidth] = useState(0);
  const prevProgress = useRef(progress);

  useEffect(() => {
    // Animate only if progress changed
    if (progress !== prevProgress.current) {
      setWidth(progress);
      prevProgress.current = progress;
    } else {
      setWidth(progress);
    }
  }, [progress]);

  const style = {
    width: `${width}%`,
    transition: "width 1.5s ease-in-out",
  };

  return (
    <div className={itemClass || "it-progress-bar"}>
      <div className="progress">
        <div
          className={progressClass || "progress-bar"}
          data-wow-delay=".1s"
          data-wow-duration="2s"
          style={style}
        >
          <span>{progress} Years</span>
        </div>
      </div>
    </div>
  );
};

export default SingleProgress;
